@if (pages() > 0) {
    <div class="cerrix-pagination-ghost-container">
        <div></div>
        @for (i of ghostSlots(); track $index) {
            <div></div>
        }
        <div></div>
    </div>
    <div class="cerrix-pagination-container">
        <mat-icon
            class="page-arrow"
            (click)="updatePage(currentPage() - 1)"
            [class.disabled]="currentPage() === 1"
            [svgIcon]="'arrow-left'"
        ></mat-icon>
        <div class="page-number-container">
            @for (v of pagination(); track $index) {
                @if (v === -1) {
                    <span class="page-ellipsis">…</span>
                } @else {
                    <span
                        class="page-number"
                        [class.active]="v === currentPage()"
                        (click)="updatePage(v)"
                    >
                        {{ v }}
                    </span>
                }
            }
        </div>

        <mat-icon
            class="page-arrow"
            (click)="updatePage(currentPage() + 1)"
            [class.disabled]="currentPage() === pages()"
            [svgIcon]="'arrow-right'"
        ></mat-icon>
    </div>
}
